import {createSelectItem} from "components/Select";
import Tr from "translations/Translations";

export const ITEM_TYPES = {
    BASIC: "basic",
    OPTIONAL: "optional",
}

export const ItemTypes = [
    createSelectItem(ITEM_TYPES.BASIC, Tr('position_type.basic')),
    createSelectItem(ITEM_TYPES.OPTIONAL, Tr('position_type.optional'))
]